export default function LedgerStat({ label, value, mono, suffix }) {
  return (
    <div className="ledger-stat-cell">
      <div className="ledger-stat-label">{label}</div>
      <div className={`ledger-stat-value${mono ? ' ledger-mono' : ''}`}>
        {value}
        {suffix}
      </div>
    </div>
  )
}
